import { DeleteClinicalDocs } from '~/domain/usecases/clinicalDocs/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
} from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteDeleteClinicalDocs implements DeleteClinicalDocs {
  private readonly url: string;

  private readonly httpClient: HttpClient<DeleteClinicalDocs.Model>;

  constructor(url: string, httClient: HttpClient<DeleteClinicalDocs.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  delete = async (
    params: DeleteClinicalDocs.Params,
  ): Promise<DeleteClinicalDocs.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.docId}`,
      method: 'delete',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
